<template>
  <div class="container">
    <el-button
      type="primary"
      class="el-button credit-card-button el-button--default"
      @click="opened = !opened"
    >
      {{ $t("pay.further-button") }}
    </el-button>
    <el-drawer
      custom-class="further-payment-methods-drawer"
      :visible.sync="opened"
      direction="btt"
      size="38%"
    >
      <template #default>
        <div class="content">
          <slot />
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "FurtherMethods",
  data() {
    return {
      opened: false,
    };
  },
  props: {
    qrCodes: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    opened: function(val) {
      if (val) {
        this.$amplitude.logEvent(
          `Payment page event Further methods button clicked`,
          {
            qrCode: this.qrCodes.join(","),
          }
        );
      } 
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
}
.credit-card-button::v-deep {
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #fff;
  border: 1px solid #2c2e2f;
  border-radius: 4px;
  margin: 12px auto 0 auto;
  color: #2d2e2f;
}

.content {
  max-width: 320px;
  margin: 0 auto;
}
</style>

<style lang="scss">
.el-popup-parent--hidden {
  padding-right: 0 !important;
}

.further-payment-methods-drawer {
  .el-drawer__header {
    margin-bottom: 0 !important;
  }
}
</style>
